import { User, Organization } from '../api';

export type Page = 'dashboard' | 'profile' | 'admin' | 'uploads';

interface SidebarProps {
  user: User | null;
  organization: Organization | null;
  currentPage: Page;
  onPageChange: (page: Page) => void;
  onLogout: () => void;
  hasOwnerProject: boolean;
}

export function Sidebar({
  user,
  organization,
  currentPage,
  onPageChange,
  onLogout,
  hasOwnerProject,
}: SidebarProps) {
  const canSeeUploads = hasOwnerProject || user?.role === 'org_admin';

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>{organization?.name || 'Organization'}</h2>
      </div>
      <nav className="sidebar-nav">
        <button
          className={currentPage === 'dashboard' ? 'active' : ''}
          onClick={() => onPageChange('dashboard')}
        >
          Dashboard
        </button>
        {canSeeUploads && (
          <button
            className={currentPage === 'uploads' ? 'active' : ''}
            onClick={() => onPageChange('uploads')}
          >
            Uploads
          </button>
        )}
        {user?.role === 'org_admin' && (
          <button
            className={currentPage === 'admin' ? 'active' : ''}
            onClick={() => onPageChange('admin')}
          >
            Admin
          </button>
        )}
      </nav>
      <div className="sidebar-footer">
        <div
          className="user-info clickable"
          onClick={() => onPageChange('profile')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && onPageChange('profile')}
        >
          <div className="user-avatar">
            {user?.first_name?.[0] || user?.email?.[0] || '?'}
          </div>
          <div className="user-details">
            <span className="user-name">
              {user?.first_name && user?.last_name
                ? `${user.first_name} ${user.last_name}`
                : user?.email || 'User'}
            </span>
            <span className="user-role">{user?.role === 'org_admin' ? 'Admin' : 'Member'}</span>
          </div>
        </div>
        <button className="logout-btn" onClick={onLogout}>
          Sign Out
        </button>
      </div>
    </aside>
  );
}
